<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Эмнэлгийн үйлчилгээ, журам (Амбулатори)</h3>
            <div class="img-wrap">
                <img alt="" class="" src="/resource/img/">
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Анхны үзлэг(анх удаа үзүүлж байгаа) бол</h3>
            <h4 class="depth bullet02">Цаг захиалалгүй тухайн өдрөө бүртгүүлэн үзүүлж байгаа бол</h4>
            <p class="depth">
                Газар доорх 1-3 дугаар давхарт байрлуулсан эмчлүүлэгчийн анкетыг бөглөнө үү. Хүлээлгийн дугаар авсны дараа дугаарын дагуу бүртгэлийн цонхон дээр очиж эмчлүүлэгчийн анкет, эрүүл мэндийн даатгалын дэвтэр, биеийн байцаалтаа өгвөл амбулаторийн цаг захиалгын хуудас болон эмчлүүлэгчийн үнэмлэх олгоно. Та үзүүлэх гэж байгаа тасагтаа очоод ажилтанд нь захиалгын хуудсаа өгөөрэй.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Давтан үзлэг(дахин үзүүлж байгаа) бол</h3>

            <h4 class="depth bullet02">Үзлэгийн цагийг урьдчилан захиалсан бол</h4>
            <p class="depth">Захиалга өгсөн цагаас 10 орчим минутын өмнө үзүүлэх тасаг руу шууд очно.</p>
            <p class="depth">Тухайн тасгийн ажилтанд захиалгын хуудсаа өгөөрэй.</p>

            <h4 class="depth bullet02">Суурин утсаар болон бусад холбоо харилцааны хэрэгсэлээр(утас, интернэт, мобайл) захиалсан бол</h4>
            <p class="depth">Захиалга өгсөн цагаас 10 орчим минутын өмнө үзүүлэх тасаг руу шууд очно.</p>
            <p class="depth">Захиалгын мэдээлэл бүхий мессежийг тухайн тасгийн ажилтанд үзүүлнэ үү.</p>

            <h4 class="depth bullet02">Цаг захиалалгүй тухайн өдрөө бүртгүүлэн үзүүлж байгаа бол</h4>
            <p class="depth">Хүлээлгийн дугаар авсны дараа дугаарын дагуу бүртгэлийн цонхон дээр очиж эмчлүүлэгчийн анкет, эрүүл мэндийн даатгалын дэвтэр, биеийн байцаалтаа өгвөл амбулаторийн цаг захиалгын хуудас олгоно. Та үзүүлэх гэж байгаа тасагтаа очоод ажилтанд нь захиалгын хуудсаа өгөөрэй.</p>
            <p class="depth font-sub">※ Тухайн өдрийн ачааллаас хамаарч зарим үзлэгийн цаг эрт дуусах магадлалтай.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>